import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'antim-autoware-card',
  standalone: false,
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss'
})
export class CardComponent {

  @Input() title = '';
  @Input() subtitle = '';
  @Input() customCard = '';
  @Input() addAddressFlag = false;
  @Input() addCarFlag = false;
  @Input() orderItemId = 0;

  constructor(private router: Router) {
  }

  // addNewAddress() {
  //   this.router.navigate(["/" + Paths.admin + "/" + Paths.master + "/" + Paths.userAddress + "/" + this.orderItemId]);
  // }

}
